import Vue from 'vue'
import Router from 'vue-router'
import Gantt from './components/Gantt.vue'
import AuthLogin from './components/AuthLogin.vue'
import PageNotFound from './components/PageNotFound.vue'

import store from '@/store/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Gantt,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: AuthLogin
    },
    {
      path: '*',
      name: 'NotFound',
      component: PageNotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log(`Навигация к ${to.name} от ${from.name}`)

  if (to.matched.some(route => route.meta.requiresAuth)) {
    store.dispatch('auth/initAuth')
    .then(() => {
      if (!store.getters['auth/getAuthStatus']) {
        next({ name: 'Login' })
      } else {
        next()
      }
    })
  } else {
    next()
  }
})

export default router
